import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-attr-string',
  templateUrl: './attr-string.component.html',
  styleUrls: ['./attr-string.component.scss'],
  standalone: false,
})
export class AttrStringComponent implements OnInit {
  @Input() propertyId: string;
  @Input() caption: string;
  @Input() value: string;
  @Input() mandatory: boolean;
  @Input() isDisabled: boolean;

  constructor() {}

  ngOnInit(): void {}
}
